import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';

import { useDeviceSelector, useUserSelector } from '@core/js/store/hooks';

export const useGetBannerDataAttr = () => {
    const { pathname } = useLocation();
    const isMobile = useDeviceSelector(prop('isMobile'));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    const dataAttrKey = useMemo(() => `data-${pathname.slice(1) || 'home'}-banner`, [pathname]);

    return useCallback((slideIndex: number) => {
        if (!isMobile || !isLoggedIn) {
            return {};
        }

        return {
            [dataAttrKey]: slideIndex + 1
        };
    }, [dataAttrKey, isLoggedIn, isMobile]);
};
